import {
  SET_TRANSACTION,
  SET_DBET_DATA,
  SET_PROVIDER_DATA,
  IS_DBET_LOADED,
  CLEAR_NOTIFICATION,
  WAIT_FOR_TRANSACTION,
  SET_FINAL_TRANSACTION,
  SET_CONTRACT_TRANSACTION,
} from 'store/actions/actionTypes';
import {
  SYNC,
  SEND_TO,
  DEPOSIT,
  WITHDRAW,
  PREPARE_WITHDRAW,
  CANCEL_WITHDRAW,
  CREATE_CHANNEL,
  contractTransactionMapping,
} from 'constants/dbetSDK';

const defaultState = {
  data: null,
  providerData: {},
  dbetIsLoaded: false,
  transactionResult: {
    [SYNC]: null,
    [SEND_TO]: null,
    [DEPOSIT]: null,
    [WITHDRAW]: null,
    [PREPARE_WITHDRAW]: null,
  },
  waitForTransaction: {
    [SYNC]: false,
    [SEND_TO]: false,
    [DEPOSIT]: false,
    [WITHDRAW]: false,
    [PREPARE_WITHDRAW]: false,
    [CANCEL_WITHDRAW]: false,
    [CREATE_CHANNEL]: false,
  },
  finalTransaction: {},
  contractTransaction: {},
};

function dbetReducer(state = defaultState, action) {
  switch (action.type) {
    case IS_DBET_LOADED:
      return {
        ...state,
        dbetIsLoaded: true,
      };
    case SET_DBET_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case SET_PROVIDER_DATA:
      return {
        ...state,
        providerData: action.payload,
      };
    case SET_FINAL_TRANSACTION:
      return {
        ...state,
        finalTransaction: {
          ...state.finalTransaction,
          [action.payload.type]: action.payload.transaction,
        },
      };
    case SET_TRANSACTION:
      const { type: transactionType, ...rest } = action.payload;

      return {
        ...state,
        transactionResult: {
          ...state.transactionResult,
          [transactionType]: {
            transactionType,
            ...rest,
          },
        },
        currentTransaction: transactionType,
      };
    case WAIT_FOR_TRANSACTION:
      const { type, pending } = action.payload;

      return {
        ...state,
        waitForTransaction: {
          ...state.waitForTransaction,
          [type]: pending,
        },
      };
    case CLEAR_NOTIFICATION:
      return {
        ...state,
        transactionResult: {
          ...state.transactionResult,
          [action.payload]: null,
        },
      };
    case SET_CONTRACT_TRANSACTION:
      const currentTransactionType = action.payload.action;

      return {
        ...state,
        contractTransaction: {
          type: contractTransactionMapping[currentTransactionType],
          ...action.payload,
        },
      };
    default:
      return state;
  }
}

export default dbetReducer;
